'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var arms = {
    error: function error(_error, pos) {
        if (window.__bl && window.__bl.error) {
            window.__bl.error(_error, pos);
        } else if (window.__bl) {
            window.__bl.pipe = window.__bl.pipe || [];
            window.__bl.pipe.push(['error', _error, pos]);
        }
    },


    api: {
        success: function success(url, time, code, error) {
            if (window.__bl && window.__bl.api) {
                window.__bl.api(url, true, time, code, error);
            } else if (window.__bl) {
                window.__bl.pipe = window.__bl.pipe || [];
                window.__bl.pipe.push(['api', url, true, time, code, error]);
            }
        },
        error: function error(url, time, code, _error2) {
            if (window.__bl && window.__bl.api) {
                window.__bl.api(url, false, time, code, _error2);
            } else if (window.__bl) {
                window.__bl.pipe = window.__bl.pipe || [];
                window.__bl.pipe.push(['api', url, false, time, code, _error2]);
            }
        }
    }
};

exports.default = arms;